import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchGallery = async () => {
  const res = await axios.get(`${API}/gallery`);
  return res.data;
};

export const submitContact = async ({ pdf, ...payload }) => {
  const fd = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") fd.append(k, v);
  });
  if (pdf) fd.append("pdf", pdf, pdf.name);
  const res = await axios.post(`${API}/contact`, fd);
  return res.data;
};
